import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-archive-book',
  imports: [],
  templateUrl: './icon-archive-book.component.html',
})
export class IconArchiveBookComponent {
  @Input() color: string = '#171717';
  @Input() size: string = '24px';
}
